module.exports = "/lucky-balls/img/jackpot/011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/011.png
// module id = 1111
// module chunks = 0